"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var owa_options_store_1 = require("owa-options-store");
var owa_header_store_1 = require("owa-header-store");
var confirmDirtyOptionsAndPerformAction_1 = require("./confirmDirtyOptionsAndPerformAction");
exports.default = satcheljs_1.orchestratorAction('hideFullOptions', function hideFullOptions(showQuickOptions) {
    var continueAfterConfirmCallback = function () {
        owa_options_store_1.setIsFullOptionsShown(false);
        if (showQuickOptions) {
            owa_header_store_1.toggleCharm(4 /* SettingsCharm */);
        }
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=hideFullOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/hideFullOptions.js
// module id = 5279
// module chunks = 2